import { render, staticRenderFns } from "./setting-block.vue?vue&type=template&id=7d5e73e7&scoped=true&"
import script from "./setting-block.vue?vue&type=script&lang=js&"
export * from "./setting-block.vue?vue&type=script&lang=js&"
import style0 from "./setting-block.vue?vue&type=style&index=0&id=7d5e73e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5e73e7",
  null
  
)

export default component.exports